//@ts-check
"use strict";

const KTUtil = require("../../components/util");
const EventListener = require("./event-listener");
const QFavoriteButton = require("./q-favorite-button");
// @ts-ignore
const { effect, computed, signal } = require('@node_modules/@preact/signals-core');
const { getTreeviewSubSectionItems, getTreeviewSubSectionItemsWithPath } = require("./helpers");
const QBreadCrumbMegaMenu = require("./q-bread-crumb-mega-menu");

class QMegaMenu {
    constructor(elementId, config, dependencies) {
        /** @type {JQuery<HTMLElement>} */ this._element = $(`#${elementId}`);

        // if (!this._element) return {};

        /** @type {{sections: import("./q-menu").Section[]}} */
        this._menuConfig = config.menuConfig;
        this._templates = config.template;
        this._lazy =  config.lazyLoad;
        this._treeview = dependencies.treeview;
        this._treeviewInstance = null;
        this._searchQuery = signal('');
        this._plainItems = this._buildPlainItems();
        this._filterComparefunc = this._setCompareFunc(config);
        this._useTitleConfig = config.useTitle;
        this._productName = config.productName;
        this._effectsForCleanUp = [];
        this._homeRoute = config.homeRoute;
        this._scrollPositionKey = config.saveScrollPosition;
        this._eventListener = this._setEventListeners();
        this._build();
    }

    _buildPlainItems() {
        const getItems = (items) => {
            return items.reduce((quickAcessItems, item) => {
                if(!item.items) return [...quickAcessItems, item];
                if (item.withTreeview) return [...quickAcessItems, ...getTreeviewSubSectionItems(item.items)];

                return [...quickAcessItems, ...getItems(item.items)];
            }, []);
        };

        return getItems(this._menuConfig.sections.filter((section) => !section.isCompany && !section.isQuickAccess));
    }

    _setCompareFunc(config) {
        if (config.filterCompareFunc) return config.filterCompareFunc;

        const normalize = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[.*+?^${}()|[\]\\]/g, '\\$&').toLowerCase();
        
        return (text1 = '', text2 = '') => normalize(text1).match(normalize(text2));
    }

    _cleanUpEffects() {
        this._effectsForCleanUp.forEach((dispose) => {
            if (typeof dispose == 'function') dispose();
        });
        this._effectsForCleanUp = [];
    }

    _build() {
        const button = this._buildButton();
        const modal = this._buildDropdown();
        
        this._element.append(button);
        this._element.addClass('topbar');
        $(document.body).append(modal);
    }

    _buildWrapper() {
    }

    _buildButton() {
        return $(/*html*/`
            <div data-toggle="modal" data-target="#q_mega_menu_modal" class="btn btn-icon w-auto btn-clean d-flex alignitems-center btn-md px-2 mr-3">
                <i class="text-white font-size-h2 las la-bars"></i>
                <span class="text-white font-size-h4 ml-2">Todos os recursos</span>
            </div>
        `)
        .css('height', '40px')
        .tooltip({
            placement: 'bottom',
            title: `Explore e acesse todas as opções do ${this._productName || ''}`,
        });
    }

    _buildDropdown() {
        const modal = $(/*html*/`
            <div class="modal" id="q_mega_menu_modal" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
                <div
                    class="modal-dialog q-modal-dialog-scrollable h-100" 
                    style="max-width: 80%;"
                    role="document"
                >
                    <div class="modal-content">
                        <div class="modal-header p-0 flex-column">
                            <div class="d-flex justify-content-between align-items-center w-100 border-bottom px-7 py-6">
                                <h5 class="modal-title" id="exampleModalLabel">Todos os recursos</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <i aria-hidden="true" class="ki ki-close"></i>
                                </button>
                            </div>
                            <div class="bg-gray-100 w-100 d-flex justify-content-center py-2">
                                <div id="q_mega_menu_search" class="form-group m-0 w-50">
                                    <label class="font-size-h6 m-0 w-100">
                                        O que você está procurando?
                                        <input type="text" class="form-control form-control-sm" placeholder="Pesquisar...">
                                    </label>
                                </div>
                            </div>
                             <div class="d-flex px-6 w-100 breadcrumb-mega-menu ">
                                <ul class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-0 font-size-sm"></ul>
                             </div>
                        </div>
                        <div class="modal-body custom-scrollbar">
                            <div id="content" class="row"></div>
                            <div class="scroll-top justify-content-center ml-auto align-items-center">
                                <span class="svg-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <polygon points="0 0 24 0 24 24 0 24"></polygon>
                                            <rect fill="#000000" opacity="0.3" x="11" y="10" width="2" height="10" rx="1"></rect>
                                            <path d="M6.70710678,12.7071068 C6.31658249,13.0976311 5.68341751,13.0976311 5.29289322,12.7071068 C4.90236893,12.3165825 4.90236893,11.6834175 5.29289322,11.2928932 L11.2928932,5.29289322 C11.6714722,4.91431428 12.2810586,4.90106866 12.6757246,5.26284586 L18.6757246,10.7628459 C19.0828436,11.1360383 19.1103465,11.7686056 18.7371541,12.1757246 C18.3639617,12.5828436 17.7313944,12.6103465 17.3242754,12.2371541 L12.0300757,7.38413782 L6.70710678,12.7071068 Z" fill="#000000" fill-rule="nonzero"></path>
                                        </g>
                                    </svg>
                                </span>
                            </div>
                        </div>
                        <div class="modal-footer py-2 border-0"></div>
                    </div>
                </div>
            </div>
        `);

        const shouldUpdateBreadCrumb = signal({});
        const updateBreadCrumb = () => shouldUpdateBreadCrumb.value = { };

        this._setScrollTopEvent(modal);
        this._setSearchEvent(modal);
        this._createBreadCrumb(modal, shouldUpdateBreadCrumb);

        if (this._lazy) {
            const buildModalItems = () => {  
                $('#content', modal).append(this._buildSections());

                updateBreadCrumb();
            };

            modal.on('show.bs.modal', () => {
                this._preventScrollSave = true;

                buildModalItems();
            });

            modal.on('hide.bs.modal', () => {
                if (this._treeviewInstance) {
                    this._treeviewInstance.dispose();
                    this._treeviewInstance.element().remove();
                    this._cleanUpEffects();
                }   

                $('#content', modal).empty();
            })
        }
        else {
            $('#content', modal).append(this._buildSections());

            updateBreadCrumb();
        }


        if (this._scrollPositionKey) {
            modal.find('.custom-scrollbar').on('scroll', (e) => {
                this._setScrollPosition(e.currentTarget.scrollTop);
            })

            modal.on('shown.bs.modal', () => {
                modal.find('.custom-scrollbar').scrollTop(Number(this._getScrollPosition()));
             
                this._preventScrollSave = false
            });
        }

        return modal;
    }

    _setScrollPosition(scrollPosition = 0) {
        if (this._preventScrollSave) return;

        localStorage.setItem(this._scrollPositionKey, `${scrollPosition}`);
    }

    _getScrollPosition() {
        return localStorage.getItem(this._scrollPositionKey) || 0;
    }

    resetScrollPosition() {
        localStorage.removeItem(this._scrollPositionKey)
    }

    _createBreadCrumb(modal, shouldUpdate) {
        QBreadCrumbMegaMenu({
            shouldUpdate: shouldUpdate,
            breadCrumbElement: $('.breadcrumb-mega-menu ul', modal),
            scrollableContent: $('.modal-body.custom-scrollbar', modal),
            plainItems: this._plainItems,
            useTitleConfig: this._useTitleConfig,
            sections: this._menuConfig.sections.filter((section) => !section.isCompany && !section.isCompany),
            homeRoute: this._homeRoute,
            events: {
                dispatchEvent: this._dispatchEvent.bind(this)
            },
        });
    }

    _setScrollTopEvent(modal) {
        const element = modal.find('.scroll-top');
        const scrollable = $('.custom-scrollbar', modal);

        if (!element.length) return;

        let timer;
        
        scrollable.on('scroll', function () {
            KTUtil.throttle(timer, function () {
                var pos = scrollable.scrollTop() || 0;

                if (pos > 200) {
                    if (!element.attr('data-scrolltop')) {
                        element.attr('data-scrolltop', 'on');
                    }
                }
                else {
                    if (element.attr('data-scrolltop')) {
                        element.removeAttr('data-scrolltop');
                    }
                }
            }, 200);
        });

        element.on('click', function() {
            scrollable.get(0).scrollTo(0, 0);
        });
    }

    _setSearchEvent(modal) {
        const input = $('#q_mega_menu_search input', modal);

        function debounce(func, timeout = 500) {
            let timer;
            return (...args) => {
                clearTimeout(timer);
                timer = setTimeout(() => { func.apply(this, args); }, timeout);
            };
        }

        const handleInput = (event) => {
            const searchQuery = event.currentTarget.value;

            this._plainItems.forEach((item) => {
                const match = this._filterComparefunc(item.caption, searchQuery);
                const isVisible = match || !searchQuery;

                item.isVisible.value = isVisible;
            });

            this._searchQuery.value = searchQuery;
        }

        input.on('keyup', debounce(handleInput));
    }

    _buildSections() {
        let separatorConf = 0;

        return this._menuConfig.sections
            .filter((section) => !section.isCompany && !section.isQuickAccess)
            .map((section, index, sections) => {
                separatorConf = (section.columnSize || 12) + separatorConf;
                const separadorConfSection = separatorConf;

                const hasSeparator = computed(() => {
                    const hasPreviousSectionVisible = Boolean(sections.slice(0, index).find((previousSection) => previousSection.isVisible.value));

                    return separadorConfSection > 12 && hasPreviousSectionVisible;
                });

                return this._buildSection(section, { hasSeparator });
            });
    }

    _buildSection(section, { hasSeparator }) {  
        const sectionTemplate = (this._templates || {}).sectionTemplate;

        if (sectionTemplate) return sectionTemplate(section, hasSeparator);

        return this._sectionTemplate(section, hasSeparator);
    }

    _sectionTemplate(section, hasSeparator) {
        const columnSize = section.columnSize || 12;
        const sectionEl = $(/*html*/`
            <div class="mega-menu-section col-${columnSize} ${hasSeparator.peek() ? 'd-flex flex-column q-mega-menu-separator' : ''}">
                <span class="h1 pl-2 text-primary font-weight-bolder d-block">${section.caption}</span>
            </div>
        `);

        const itemsListEl = $(/*html*/`<ul class="navi navi-hover"></ul>`);

        const gridTemplateColumns = section.columns || Math.floor(columnSize / (section.isProduct ? 1 : 4));

        const itemElements = this._buildSectionItems(section, { gridTemplateColumns: gridTemplateColumns });

        itemsListEl.append(itemElements);

        itemsListEl.css({
            display: 'grid',
            'grid-template-columns': `repeat(${gridTemplateColumns}, minmax(0, 1fr))`
        });

        this._effectsForCleanUp.push(effect(() => {
            section.isVisible.value = Boolean(section.items.find(item => item.isVisible.value));

            sectionEl.toggleClass('hide-search', !section.isVisible.value);
        }));

        this._effectsForCleanUp.push(effect(() => {
            sectionEl.toggleClass('d-flex flex-column q-mega-menu-separator', hasSeparator.value);
        }));

        if (!section._megaMenu) section._megaMenu = {};

        section._megaMenu.sectionElement = sectionEl;

        return sectionEl.append(itemsListEl)
    }

    _buildSectionItems(section, options) {
        const sectionItems = section.items;
        const itemElements = [];

        if (this._useTitleConfig) {
            const withTitle = [];
            let withTitleIndex = 0;
    
            sectionItems.forEach((item, index) => {
                if (item.title && index) {
                    withTitleIndex++;
                }
    
                if (!withTitle[withTitleIndex]) {
                    withTitle[withTitleIndex] = {
                        range: [index, index],
                        items: [item]
                    }
                }
                else {
                    withTitle[withTitleIndex].range[1] = index;
                    withTitle[withTitleIndex].items.push(item);
                }
            });
    
            withTitle.forEach((titleGroup) => {
                const firstGroupItem = titleGroup.items[0];

                if (typeof firstGroupItem.title == 'undefined') return;

                firstGroupItem.isTitleVisible = computed(() => Boolean(titleGroup.items.find((subSection) => subSection.isVisible.value)));
            });
    
            sectionItems.forEach((item, index) => {
                if (item.items) {
                    const titleGroup = withTitle.find(({ range }) => (index >= range[0] && index <= range[1]));
                    const groupPosition = titleGroup.items.indexOf(item);    
                    const firstGroupItem = titleGroup.items[0];

                    const hasSeparator = computed(() => {
                        const hasPreviousVisibleItemInGroup = titleGroup.items.slice(0, groupPosition).toReversed().find((previousItem) => previousItem.isVisible.value);
                        const hasTitleVisibleInGroup = firstGroupItem.isTitleVisible.value;

                        return (Boolean(hasPreviousVisibleItemInGroup) || !(hasTitleVisibleInGroup || groupPosition == 0))
                    });
    
                    if (item.title) {
                        item.hasTitleSeparator = computed(() => Boolean(sectionItems.slice(0, index).toReversed().find((previousItem) => previousItem.isVisible.value)));
                    }

                    this._buildSubSection(item, { hasSeparator, gridTemplateColumns: options.gridTemplateColumns, itemIndex: index }).forEach((item) => itemElements.push(item));
                }
                else {
                    if (item.title) {
                        const hasTitleSeparator = computed(() => Boolean(sectionItems.slice(0, index).toReversed().find((previousItem) => previousItem.isVisible.value)));

                        itemElements.push(this._titleTemplate(item, { hasTitleSeparator, gridTemplateColumns: options.gridTemplateColumns }));
                    }
                    itemElements.push(this._buildItem(item));
                }
            });
        }
        else {
            sectionItems.forEach((item, index) => {
                if (item.items) {   
                    const hasSeparator = computed(() => {
                        const hasPreviousVisibleItem = sectionItems.slice(0, index).toReversed().find((previousItem) => previousItem.isVisible.value);

                        return Boolean(hasPreviousVisibleItem);
                    });
    
                    this._buildSubSection(item, { hasSeparator, gridTemplateColumns: options.gridTemplateColumns, itemIndex: index }).forEach((item) => itemElements.push(item));
                }
                else {
                    itemElements.push(this._buildItem(item));
                }
            });
        }

        return itemElements;
    }

    _buildSubSection(subSection, options) {
        if (!subSection._megaMenu) subSection._megaMenu = {};

        if (subSection.withTreeview) {
            const subsectionEl = this.createTreeviewSubSection(subSection, {
                hasSeparator: computed(() => options.hasSeparator.value && !subSection.title),
                gridTemplateColumns: options.gridTemplateColumns
            });

            const findVisible = (item) => {
                return Boolean(item.menuItems.find((subItem) => subItem.isVisible.value) || item.items.find(findVisible));
            };

            this._effectsForCleanUp.push(effect(() => {
                subSection.isVisible.value = findVisible(subSection.items);
            }));

            subSection._megaMenu.subSectionElement = subsectionEl;
            
            if (subSection.title) {
                const titleEl = this._titleTemplate(subSection, options);

                subSection._megaMenu.titleElement = titleEl;

                return [titleEl, subsectionEl];
            }

            return [subsectionEl];
        }

        const items = [];
        const hasCategory = Boolean(subSection.items.find((subItem) => subItem.items));

        if (subSection.title) {
            const titleEl = this._titleTemplate(subSection, options);

            subSection._megaMenu.titleElement = titleEl;

            items.push(titleEl);
        }

        if(hasCategory) {
            subSection.items.forEach((category) => {
                this._effectsForCleanUp.push(effect(() => {
                    category.isVisible.value = Boolean(category.items.find((item) => item.isVisible.value));
                }));

                this._categoryTemplate(subSection, category, options).forEach((item) => items.push(item));
            });

            this._effectsForCleanUp.push(effect(() => {
                subSection.isVisible.value = Boolean(subSection.items.find(category => category.isVisible.value));
            }));

            subSection._megaMenu.subSectionElement = items[0];
        }
        else {
            const subSectionTemplate = (this._templates || {}).subSectionTemplate;
            const subSectionEl = subSectionTemplate
                ? subSectionTemplate()
                : this._subSectionTemplate(subSection, {
                    hasSeparator: options.hasSeparator,
                    gridTemplateColumns: options.gridTemplateColumns
                });
    
            this._effectsForCleanUp.push(effect(() => {
                subSection.isVisible.value = Boolean(subSection.items.find((item) => item.isVisible.value));
            }));

            items.push(subSectionEl);

            subSection.items.forEach((subItem) => {
                items.push(this._buildItem(subItem));
            });
    
            subSection._megaMenu.subSectionElement = subSectionEl;
        }

        return items;
    }

    _categoryTemplate(subSection, category, options) {
        const subSectionEl = this._subSectionTemplate(subSection, {
            gridTemplateColumns: options.gridTemplateColumns,
            hasSeparator: options.hasSeparator,
        }, category);

        const items = [subSectionEl];

        category.items.forEach((menuItem) => {
            items.push(this._buildItem(menuItem));
        });

        return items;
    }

    createTreeviewSubSection(subSection, options) {
        const sectionItem = this._subSectionTemplate(subSection, options);
        const subSectionContent = $('<div class="d-flex w-100 pl-6 mega-menu-not-configured">')
        const treeviewColumn = $('<div class="treeview-column">');
        const contentColumn = $('<ul class="content-column p-0">');
        const columnSeparator = $('<div class="column-separator">')
        const dataSource = subSection.items.menuItems.length ? [subSection.items] : subSection.items.items;
        const allItemsWithPath = getTreeviewSubSectionItemsWithPath(subSection.items);
        const getSelectedNode = (node) => {
            if (!node) return;

            if (Array.isArray(node)) {
                let selectedNode;

                node.find((n) => selectedNode = getSelectedNode(n));

                return selectedNode;
            }
            if (node.selected) {
                return node;
            }

            return getSelectedNode(node.children)
        };

        const createContent = (component, contentElement) => {
            const selectedNode = component ? getSelectedNode(component.getNodes()) : null;

            contentElement.empty();

            if (selectedNode && selectedNode.itemData) {
                contentElement.append(selectedNode.itemData.menuItems.map((c) => this._buildItem(c, { useTooltip: true })))
            }
        };

        const createFilteredContent = (contentElement, items) => {
            const itemsEl = [];

            items.forEach((item, index) => {
                const caption = $(/*html*/
                    `<li class="navi-section py-3 px-60 flex-column align-items-start ${index ? 'q-mega-menu-separator' : ''}">
                        <span class="navi-text font-weight-bolder h2 mb-0">
                            ${item.caption}
                        </span>
                    </li>`
                ).css('grid-column-start', 'span 3');

                itemsEl.push(caption);

                item.items.forEach((menuItem) => {
                    itemsEl.push(this._itemTemplate(menuItem, { useTooltip: true }));
                })
            });

            contentElement.append(itemsEl);
        };

        this._treeviewInstance = new this._treeview(document.createElement('div'), {
            selectNodesRecursive: false,
            selectionMode: 'single',
            selectByClick: true,
            focusStateEnabled: false,
            activeStateEnabled: false,
            expandEvent: 'click',
            keyExpr: '_uuid',
            dataSource: dataSource,
            itemTemplate: (itemData) => `<span class="treeview-item-text">${itemData.caption}</span>`,
            onSelectionChanged: (e) => createContent(e.component, contentColumn)
        });  
        
        if (this._treeviewInstance.getSelectedNodesKeys().length) {
            createContent(this._treeviewInstance, contentColumn);
        }

        treeviewColumn.append(this._treeviewInstance.element());

        subSectionContent.append(treeviewColumn, columnSeparator, contentColumn);

        sectionItem
            .addClass('flex-column')
            .append(subSectionContent);

        this._effectsForCleanUp.push(effect(() => {
            const query = this._searchQuery.value;

            contentColumn.empty();

            if (query) {
                const items = allItemsWithPath
                    .map((item) => ({
                        caption: item.caption,
                        items: item.items.filter((menuItem) => this._filterComparefunc(menuItem.caption, query))
                    }))
                    .filter(item => item.items.length);

                createFilteredContent(contentColumn, items);
            }
        }));

        return sectionItem;
    }

    _subSectionTemplate(item, options, category) {
        const subSectionEl = $(/*html*/`
            <li class="navi-section p-0 m-0 d-inline-blocck w-100 flex-column ${options.hasSeparator.peek() ? 'q-mega-menu-separator' : ''}"> 
                <div class="d-flex py-3 px-6 align-items-center w-100">
                    <span class="navi-icon" style="/*flex: 0 0 2rem; line-height: 0;*/">
                        <i class="las ${item.icon || 'la-folder-open'}"></i>
                    </span>
                    <span class="navi-text font-weight-bolder h2 mb-0">
                        ${item.caption}
                    </span>
                    ${category ? /*html*/`<span class="btn btn-sm btn-pill btn-primary px-3 py-0 navi-text font-weight-bolder h2 mb-0 ml-5">${category.caption}</span>` : ''}
                </div>
            </li>
        `).css({
            'grid-column-start': `span ${options.gridTemplateColumns}`,
        });

        this._effectsForCleanUp.push(effect(() => {
            subSectionEl.toggleClass('hide-search', category ? !category.isVisible.value : !item.isVisible.value);
        }));

        this._effectsForCleanUp.push(effect(() => {
            subSectionEl.toggleClass('q-mega-menu-separator', options.hasSeparator.value);
        }));

        return subSectionEl;
    }

    _titleTemplate(item, options) {
        const hasTitleSeparator = item.hasTitleSeparator || options.hasTitleSeparator;
        const titleEl = $(/*html*/`
            <li class="navi-section p-0 m-0 d-inline-blockk w-100 ${hasTitleSeparator.peek() ? 'd-flex flex-column align-items-start q-mega-menu-separator' : ''}"> 
                <div class="d-flex py-3 px-6 align-items-center">
                    <span class="navi-text h1 mb-0 text-primary">
                        ${item.title}
                    </span>
                </span>
            </li>
        `).css({
            'grid-column-start': `span ${options.gridTemplateColumns}`
        });

        this._effectsForCleanUp.push(effect(() => {
            titleEl.toggleClass('hide-search', !item.isTitleVisible.value);
        }));

        if (hasTitleSeparator != 'undefined') {
            this._effectsForCleanUp.push(effect(() => {
                titleEl.toggleClass('d-flex flex-column align-items-start q-mega-menu-separator', hasTitleSeparator.value);
            }));
        }

        return titleEl;
    }

    _buildItem(item, options) {
        const template = (this._templates || {}).itemTemplate;

        return template
            ? template(item, options)
            : this._itemTemplate(item, options);
    }

    _itemTemplate(item, options) {
        const itemEl = $(/*html*/ `
            <li class="navi-item d-inline-block w-100">
                <a class="navi-link${item.isActive ? ' active': ''}" href="${item.href}" ${item.isProduct ? 'target="_blank"' : ''}>
                    <span class="navi-icon">
                        ${
                            item.icon 
                                ? /*html*/`<i class="las ${item.icon}"></i>`
                                : ''
                        }
                    </span>
                    ${item.isProduct ? '' : /*html*/`<span class="navi-text flex-grow-0 text-line-clamp">${item.caption}</span>`}
                    ${item.isProduct || item.isCompany ? '' : /*html*/`<span class="navi-label"></span>`}
                </a>
            </li>
        `);

        this._effectsForCleanUp.push(effect(() => {
            itemEl.toggleClass('hide-search', !item.isVisible.value);
        }));

        if (!item._megaMenu) item._megaMenu = {};

        item._megaMenu.menuElement = itemEl;

        itemEl
            .find('.navi-label')
            .append(QFavoriteButton({
                item: item,
                onClick: (event) => {
                    this._dispatchEvent({
                        type: 'favorite-click',
                        originalEvent: event,
                        item: item,
                        isFavorite: $(event.currentTarget).find('i').hasClass('la-star'),
                    });
                }
            }));

        if ((options || {}).useTooltip) {
            itemEl
                .find('a.navi-link')
                .tooltip({
                    placement: 'bottom',
                    title: item.caption,
                    container: itemEl.get(0)
                })
                .on('mouseleave', (event) => {
                    const tooltip = $(event.currentTarget).data('bs.tooltip');

                    if (tooltip) tooltip.hide();
                });
        }

        if (typeof item.onClick == 'function') {
            itemEl
                .find('a.navi-link')
                .on('click', (event) => {
                    event.preventDefault();

                    item.onClick({
                        event: event,
                        item: item,
                    });
                });    
        }

        return itemEl;
    }

    _setEventListeners() {
        return {
            'favorite-click': new EventListener(),
        }
    }

    _dispatchEvent(event) {
        if (this._eventListener[event.type]) {
            this._eventListener[event.type].dispatch(event);
        }
    }

    on(type, listener) {
        if (this._eventListener[type]) {
            this._eventListener[type].addEventListener(listener);
        }
    }

    off(type, listener) {
        if (this._eventListener[type]) {
            this._eventListener[type].removeEventListener(listener);
        }
    }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = QMegaMenu;
}